import { render, staticRenderFns } from "./RelMinisterios.vue?vue&type=template&id=48c4d7ea"
import script from "./RelMinisterios.vue?vue&type=script&lang=js"
export * from "./RelMinisterios.vue?vue&type=script&lang=js"
import style0 from "./RelMinisterios.vue?vue&type=style&index=0&id=48c4d7ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports